import {
  CREATE_ORGANIZATION_FAILURE,
  CREATE_ORGANIZATION_SUCCESS,
  CREATING_ORGANIZATION, FETCH_ORGANIZATION,
  FETCH_ORGANIZATIONS_SUCCESS, FETCHING_ORGANIZATION,
  FETCHING_ORGANIZATIONS, UPDATE_ORGANIZATION_SUCCESS, UPDATING_ORGANIZATION,
  SAVE_ORGANIZATION_FAILURE, SAVE_ORGANIZATION_SUCCESS, SAVING_ORGANIZATION,
  CLEAR_ORGANIZATION_FLAG, FETCH_ORGANIZATION_FAILURE
} from './OrganizationsConstants';

const initialState = {
  fetchingOrganizations: false,
  fetchingOrganization: false,
  organizations: [],
  organization: {
    id: '', 
    code: '', 
    gtdUser: '', 
    gtdPassword: '', 
    gtdHmac: ''
  },
  savingOrganization: false,
  savedOrganizationFlag: false,
  savedOrganizationFailureFlag: false,
  creatingOrganization: false,
  updatingOrganization: false
};

const OrganizationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_ORGANIZATIONS:
      return { ...state, fetchingOrganizations: true };
    case FETCH_ORGANIZATIONS_SUCCESS:
      return { ...state, fetchingOrganizations: false, organizations: action.organizations };
    case CREATING_ORGANIZATION:
      return { ...state, creatingOrganization: true };
    case CREATE_ORGANIZATION_SUCCESS:
      return { ...state, creatingOrganization: false };
    case CREATE_ORGANIZATION_FAILURE:
      return { ...state, creatingOrganization: false };
    case FETCHING_ORGANIZATION:
      return { ...state, fetchingOrganization: true };
    case FETCH_ORGANIZATION:
      return { ...state, fetchingOrganization: false, organization: action.organization };
    case FETCH_ORGANIZATION_FAILURE:
      return { ...state, organization: initialState.organization };
    case UPDATING_ORGANIZATION:
      return {  ...state, updatingOrganization: true };
    case UPDATE_ORGANIZATION_SUCCESS:
      return {  ...state, updatingOrganization: false };
    case SAVING_ORGANIZATION:
      return { ...state, savingOrganization: true };
    case SAVE_ORGANIZATION_FAILURE: 
      return { ...state, savingOrganization: false, savedOrganizationFailureFlag: true, savedOrganizationFlag: false };
    case SAVE_ORGANIZATION_SUCCESS: 
      return { ...state, savingOrganization: false, savedOrganizationFlag: true, savedOrganizationFailureFlag: false };
    case CLEAR_ORGANIZATION_FLAG: 
      return { ...state, savedOrganizationFailureFlag: false, savedOrganizationFlag: false};
    default:
      return state;
  }
};

export default OrganizationsReducer;



// WEBPACK FOOTER //
// ./src/redux/organizations/OrganizationsReducer.js